export default __webpack_public_path__ + "static/feedback1-22f4859b1c77c961f47d6d46d9bffc93.jpg";